"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossStyle = exports.Message = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const _1 = require(".");
exports.Wrapper = styled_components_1.default.div `
  display: ${({ show }) => (show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${({ type }) => (0, _1.getBannerTypeColor)(type)};
  position: relative;
`;
exports.Message = styled_components_1.default.div `
  font-size: 20px;
  line-height: 28px;
  margin: 8px 16px;
  text-align: center;
  color: ${({ type }) => (0, _1.getBannerTypeColor)(type)};
`;
exports.CrossStyle = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 9px;
  &:hover {
    cursor: pointer;
  }
  padding: 3px;
`;
//# sourceMappingURL=Banner.styles.js.map